export default __webpack_public_path__ + "static/media/cafeshow_behind01.8869f5d9.png";